var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { supabase } from '../../api/supabase/client.js';
var AuthService = /** @class */ (function () {
    function AuthService() {
    }
    AuthService.checkEmailExists = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var error, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase.auth.signInWithOtp({
                                email: email,
                                options: {
                                    shouldCreateUser: false
                                }
                            })];
                    case 1:
                        error = (_a.sent()).error;
                        return [2 /*return*/, !error];
                    case 2:
                        error_1 = _a.sent();
                        console.error('이메일 중복 확인 중 오류:', error_1);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.signUp = function (email, password, name) {
        return __awaiter(this, void 0, void 0, function () {
            var emailExists, _a, authData, authError, profileError, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.checkEmailExists(email)];
                    case 1:
                        emailExists = _b.sent();
                        if (emailExists) {
                            return [2 /*return*/, {
                                    success: false,
                                    error: {
                                        message: '이미 등록된 이메일입니다.'
                                    }
                                }];
                        }
                        return [4 /*yield*/, supabase.auth.signUp({
                                email: email,
                                password: password,
                                options: {
                                    data: {
                                        name: name
                                    }
                                }
                            })];
                    case 2:
                        _a = _b.sent(), authData = _a.data, authError = _a.error;
                        if (authError) {
                            console.error('회원가입 에러:', authError);
                            if (authError.message === 'User already registered') {
                                return [2 /*return*/, {
                                        success: false,
                                        error: {
                                            message: '이미 등록된 이메일입니다.'
                                        }
                                    }];
                            }
                            if (authError.message.includes('Invalid email')) {
                                return [2 /*return*/, {
                                        success: false,
                                        error: {
                                            message: '올바른 이메일 형식이 아닙니다.'
                                        }
                                    }];
                            }
                            if (authError.message.includes('Password should be at least 6 characters')) {
                                return [2 /*return*/, {
                                        success: false,
                                        error: {
                                            message: '비밀번호는 최소 6자 이상이어야 합니다.'
                                        }
                                    }];
                            }
                            return [2 /*return*/, {
                                    success: false,
                                    error: {
                                        message: '회원가입 중 오류가 발생했습니다.'
                                    }
                                }];
                        }
                        if (!authData.user) return [3 /*break*/, 4];
                        return [4 /*yield*/, supabase
                                .from('profiles')
                                .insert([
                                {
                                    id: authData.user.id,
                                    email: email,
                                    name: name,
                                }
                            ])];
                    case 3:
                        profileError = (_b.sent()).error;
                        if (profileError)
                            throw profileError;
                        _b.label = 4;
                    case 4: return [2 /*return*/, { success: true }];
                    case 5:
                        error_2 = _b.sent();
                        console.error('회원가입 중 예외 발생:', error_2);
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    message: '회원가입 중 오류가 발생했습니다.'
                                }
                            }];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.signIn = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var error, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase.auth.signInWithPassword({
                                email: email,
                                password: password,
                            })];
                    case 1:
                        error = (_a.sent()).error;
                        if (error)
                            throw error;
                        return [2 /*return*/, { success: true }];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    message: error_3 instanceof Error ? error_3.message : '로그인 중 오류가 발생했습니다.',
                                },
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase.auth.signOut()];
                    case 1:
                        error = (_a.sent()).error;
                        if (error)
                            throw error;
                        return [2 /*return*/, { success: true }];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    message: error_4 instanceof Error ? error_4.message : '로그아웃 중 오류가 발생했습니다.',
                                },
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, user, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, supabase.auth.getUser()];
                    case 1:
                        _a = _b.sent(), user = _a.data.user, error = _a.error;
                        return [2 /*return*/, { user: user, error: error }];
                }
            });
        });
    };
    AuthService.resetPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var error, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase.auth.resetPasswordForEmail(email, {
                                redirectTo: "".concat(window.location.origin, "/reset-password")
                            })];
                    case 1:
                        error = (_a.sent()).error;
                        if (error)
                            throw error;
                        return [2 /*return*/, {
                                success: true,
                                message: '비밀번호 재설정 이메일이 발송되었습니다. 이메일을 확인해주세요.'
                            }];
                    case 2:
                        error_5 = _a.sent();
                        console.error('비밀번호 재설정 중 오류:', error_5);
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    message: '비밀번호 재설정 이메일 발송에 실패했습니다.'
                                }
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.updatePassword = function (newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var error, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, supabase.auth.updateUser({
                                password: newPassword
                            })];
                    case 1:
                        error = (_a.sent()).error;
                        if (error)
                            throw error;
                        return [2 /*return*/, {
                                success: true,
                                message: '비밀번호가 성공적으로 변경되었습니다.'
                            }];
                    case 2:
                        error_6 = _a.sent();
                        console.error('비밀번호 변경 중 오류:', error_6);
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    message: '비밀번호 변경에 실패했습니다.'
                                }
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.supabase = supabase;
    return AuthService;
}());
export { AuthService };
//# sourceMappingURL=auth.service.js.map